<template>
   <div>
    <!-- header -->
    <div v-if="$store.state.isMobile === false">
        <span>
         <HeaderComponent :headerTitle="headerText" class="header-fixed" :router-link="{ name: 'rfDisposition' }" :router-link-text="organization_name === 'Voltas' || $isRelianceClient() || $isWhirlpoolClient() ? '' : 'back'"  :return-condition="true"/>
       </span>
     </div>
    <!-- loader -->
    <loading v-model:active="isLoading" :can-cancel="true" :is-full-page="fullPage" :color="primary_code"></loading>
    <!-- content -->
      <div class="container fluid grid-list-lg ml-0 ml-sm-1 mobile-container">
        <v-row justify="center" class="py-2 py-sm-4 summary-row" no-gutters>
          <!-- Quantity Card -->
          <v-col cols="12" sm="4" md="4" lg="4" class="summary-col">
            <v-card class="pa-4 quantity-card" elevation="2" rounded="lg">
              <div class="card-header-text">{{ totalQuantity ? totalQuantity.toLocaleString() : '0' }}</div>
              <div class="card-bottom-text">Quantity</div>
            </v-card>
          </v-col>

          <!-- Average Ageing Card -->
          <v-col cols="12" sm="4" md="4" lg="4" class="summary-col">
            <v-card class="pa-4 ageing-card" elevation="2" rounded="lg">
              <div class="card-header-text">{{ averageAgeingTotal ? averageAgeingTotal + ' Days' : '0 Days' }}</div>
              <div class="card-bottom-text">Average Ageing</div>
            </v-card>
          </v-col>

          <!-- Value Card -->
          <v-col cols="12" sm="4" md="4" lg="4" class="summary-col">
            <v-card class="pa-4 value-card" elevation="2" rounded="lg">
              <div class="card-header-text">
                {{ totalValuesCount ? formatToMillion(totalValuesCount) : ' 0' }}
              </div>
              <div class="card-bottom-text">Value</div>
            </v-card>
          </v-col>
        </v-row>
      <v-col class="ma-0 pa-0" wrap align-center>
      <div class="overflow-y-auto dynamic-height-dis-card scrollable-container">
        <v-row class="ma-0 pa-0" xs12>
          <v-row align="center" justify="center" class="customUI">
            <!-- brand call log -->
            <v-col cols="12" md="4" sm="6" v-if="!$isWhirlpoolClient() || organization_name === 'Blubirch'">
              <component
                :is="isMobile ? 'div' : 'router-link'"
                class="text-decoration-none"
                :to="isMobile ? undefined : { name: 'BrandCallLog' }"
                :class="{ 'disabled-span' : checkDisability(organization_name === 'Voltas' ? 'Chargeback' : 'Brand Call Log') }"
              >
                <v-card class="rounded-lg pa-4" elevation="6">
                  <!-- Title and Icon Row -->
                  <v-row align="center" justify="space-between">
                    <v-col cols="9">
                      <h4 class="text-h6 font-weight-medium mb-0 text-left">
                        {{ organization_name === 'Voltas' ? 'Chargeback' : 'Brand Call Log' }}
                      </h4>
                    </v-col>
                    <v-col cols="3" class="text-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-col>
                  </v-row>
                  <!-- Data Row -->
                  <v-row class="mt-2" no-gutters>
                    <!-- Quantity -->
                    <v-col cols="4" class="text-left d-flex">
                    <v-divider vertical class="quantity-divider"></v-divider>
                    <div class="pl-2">
                      <div class="card-sub-header-text">Quantity</div>
                      <div class="card-sub-header-value">
                        {{ inv_status_count ? 
                          Number(inv_status_count["Brand Call-Log"]?.total_count) : 0
                        }}
                      </div>
                      </div>
                    </v-col>
                    <!-- Average Ageing -->
                    <v-col cols="4" class="text-left d-flex">
                    <v-divider vertical class="quantity-ageing"></v-divider>
                    <div class="pl-2">
                      <div class="card-sub-header-text">Average Ageing</div>
                      <div class="card-sub-header-value">
                        {{ inv_status_count ?  Number(inv_status_count["Brand Call-Log"]?.disposition_bucket_ageing?.toFixed(0)) + ' Days'
                          : '0'
                        }}
                      </div>
                      </div>
                    </v-col>
                    <!-- Value -->
                    <v-col cols="4" class="text-left d-flex">
                    <v-divider vertical class="quantity-value"></v-divider>
                    <div class="pl-2">
                      <div class="card-sub-header-text">Value</div>
                      <div class="card-sub-header-value">
                        ₹ {{ inv_status_count ? formatToMillionBucket( Number(inv_status_count["Brand Call-Log"]?.total_map_value)) : '0' }}
                      </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </component>
            </v-col>
          <!-- markdown -->
            <v-col cols="12" md="4" sm="6"  v-if="organization_name !== 'Voltas'">
              <component
                  :is="isMobile ? 'div' : 'router-link'"
                  class="text-decoration-none"
                  :to="isMobile ? undefined : { name: 'MarkDown' }"
                  :class="{ 'disabled-span' : checkDisability('MarkDown') }"
                  >
                  <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                    <v-row align="center" justify="space-between">
                        <v-col cols="9">
                          <h4 class="text-h6 font-weight-medium mb-0 text-left">
                              Markdown
                          </h4>
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-col>
                    </v-row>
                    <!-- Data Row -->
                    <v-row class="mt-2" no-gutters>
                        <!-- Quantity -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-divider"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Quantity</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ?(Number(inv_status_count["Pending Transfer Out"]?.total_count)) : 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Average Ageing -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-ageing"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Average Ageing</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ?(Number(inv_status_count["Pending Transfer Out"]?.disposition_bucket_ageing?.toFixed(0))) + ' days': 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Value -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-value"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Value</div>
                              <div class="card-sub-header-value">
                                ₹{{ inv_status_count ? formatToMillionBucket( Number(inv_status_count["Pending Transfer Out"]?.total_map_value)) : '0' }}
                              </div>
                          </div>
                        </v-col>
                    </v-row>
                  </v-card>
              </component>
            </v-col>
            <!-- insurance  -->
            <v-col cols="12" md="4" sm="6"  v-if="!$isWhirlpoolClient() || organization_name === 'Blubirch'">
              <component 
                  :is="isMobile ? 'div' : 'router-link'"
                  class="text-decoration-none w-100" 
                  :to="isMobile ? undefined : { name: 'InsuranceOperationsNew'}" 
                  :class="{ 'disabled-span' : checkDisability('Insurance') }"
                  >
                  <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                    <v-row align="center" justify="space-between">
                        <v-col cols="9">
                          <h4 class="text-h6 font-weight-medium mb-0 text-left">
                              Insurance
                          </h4>
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-col>
                    </v-row>
                    <!-- Data Row -->
                    <v-row class="mt-2" no-gutters>
                        <!-- Quantity -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-divider"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Quantity</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? Number(inv_status_count.Insurance?.total_count) : 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Average Ageing -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-ageing"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Average Ageing</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? Number(inv_status_count.Insurance?.disposition_bucket_ageing?.toFixed(0)) + ' days': 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Value -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-value"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Value</div>
                              <div class="card-sub-header-value">
                                ₹{{inv_status_count ? formatToMillionBucket( Number(inv_status_count.Insurance?.total_map_value)) : 0}}
                              </div>
                          </div>
                        </v-col>
                    </v-row>
                  </v-card>
              </component>
            </v-col>
            <!-- liquidation -->
           <v-col cols="12" md="4" sm="6">
            <component 
                :is="isMobile ? 'div' : 'router-link'"
                class="text-decoration-none w-100" 
                :to="isMobile ? undefined : { name: 'liquidationNew'}"
                :class="{ 'disabled-span' : checkDisability('Liquidation') }"
                >
                <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                  <v-row align="center" justify="space-between">
                      <v-col cols="9">
                        <h4 class="text-h6 font-weight-medium mb-0 text-left">
                            Liquidation
                        </h4>
                      </v-col>
                      <v-col cols="3" class="text-right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-col>
                  </v-row>
                  <!-- Data Row -->
                  <v-row class="mt-2" no-gutters>
                      <!-- Quantity -->
                      <v-col cols="4" class="text-left d-flex">
                        <v-divider vertical class="quantity-divider"></v-divider>
                        <div class="pl-2">
                            <div class="card-sub-header-text">Quantity</div>
                            <div class="card-sub-header-value">
                              {{ inv_status_count ? Number(inv_status_count.Liquidation?.total_count || 0) : 0 }}
                            </div>
                        </div>
                      </v-col>
                      <!-- Average Ageing -->
                      <v-col cols="4" class="text-left d-flex">
                        <v-divider vertical class="quantity-ageing"></v-divider>
                        <div class="pl-2">
                            <div class="card-sub-header-text">Average Ageing</div>
                            <div class="card-sub-header-value">
                              {{ inv_status_count ? Number(inv_status_count.Liquidation?.disposition_bucket_ageing?.toFixed(0) || 0) + ' days' : 0 }}
                            </div>
                        </div>
                      </v-col>
                      <!-- Value -->
                      <v-col cols="4" class="text-left d-flex">
                        <v-divider vertical class="quantity-value"></v-divider>
                        <div class="pl-2">
                            <div class="card-sub-header-text">Value</div>
                            <div class="card-sub-header-value">
                              ₹{{ inv_status_count ? formatToMillionBucket( Number(inv_status_count.Liquidation?.total_map_value || 0) ) : 0}}
                            </div>
                        </div>
                      </v-col>
                  </v-row>
                </v-card>
            </component>
          </v-col>
          <!-- </v-row>          -->
          <!-- <v-row align="center" justify="center"> -->
            <!-- Rtv -->
            <v-col cols="12" md="4" sm="6"  v-if="!$isWhirlpoolClient() || organization_name === 'Blubirch'">
                <component 
                    :is="isMobile ? 'div' : 'router-link'"
                    class="text-decoration-none w-100" 
                    :to="isMobile ? undefined : { name: 'RTVModule'}"
                    :class="{ 'disabled-span' : checkDisability('RTV') }"
                    >
                    <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                      <v-row align="center" justify="space-between">
                          <v-col cols="9">
                            <h4 class="text-h6 font-weight-medium mb-0 text-left">
                                RTV
                            </h4>
                          </v-col>
                          <v-col cols="3" class="text-right">
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-col>
                      </v-row>
                      <!-- Data Row -->
                      <v-row class="mt-2" no-gutters>
                          <!-- Quantity -->
                          <v-col cols="4" class="text-left d-flex">
                            <v-divider vertical class="quantity-divider"></v-divider>
                            <div class="pl-2">
                                <div class="card-sub-header-text">Quantity</div>
                                <div class="card-sub-header-value">
                                  {{inv_status_count ? (Number(inv_status_count["RTV"]?.total_count)): 0}}
                                </div>
                            </div>
                          </v-col>
                          <!-- Average Ageing -->
                          <v-col cols="4" class="text-left d-flex">
                            <v-divider vertical class="quantity-ageing"></v-divider>
                            <div class="pl-2">
                                <div class="card-sub-header-text">Average Ageing</div>
                                <div class="card-sub-header-value">
                                  {{inv_status_count ? (Number(inv_status_count["RTV"]?.disposition_bucket_ageing?.toFixed(0) || 0) + ' days'): 0}}
                                </div>
                            </div>
                          </v-col>
                          <!-- Value -->
                          <v-col cols="4" class="text-left d-flex">
                            <v-divider vertical class="quantity-value"></v-divider>
                            <div class="pl-2">
                                <div class="card-sub-header-text">Value</div>
                                <div class="card-sub-header-value">
                                  ₹{{inv_status_count ? formatToMillionBucket(Number(inv_status_count["RTV"]?.total_map_value)) : 0}}
                                </div>
                            </div>
                          </v-col>
                      </v-row>
                    </v-card>
                </component>
              </v-col>
            <!-- Restock bucket -->
            <v-col cols="12" md="4" sm="6"  v-if="!$isWhirlpoolClient() || organization_name === 'Blubirch'">
              <component :is="isMobile ? 'div' : 'router-link'" class="text-decoration-none w-100" :to="isMobile ? undefined : { name: 'RestockComp'}" :class="{ 'disabled-span' : checkDisability('Restock') }">
                  <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                    <v-row align="center" justify="space-between">
                        <v-col cols="9">
                          <h4 class="text-h6 font-weight-medium mb-0 text-left">
                              Restock
                          </h4>
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-col>
                    </v-row>
                    <!-- Data Row -->
                    <v-row class="mt-2" no-gutters>
                        <!-- Quantity -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-divider"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Quantity</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? (Number(inv_status_count["Restock"]?.total_count)) : 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Average Ageing -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-ageing"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Average Ageing</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? (Number(inv_status_count["Restock"]?.disposition_bucket_ageing?.toFixed(0))) + ' days': 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Value -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-value"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Value</div>
                              <div class="card-sub-header-value">
                                ₹{{inv_status_count ? formatToMillionBucket(Number(inv_status_count["Restock"]?.total_map_value)) : 0}}
                              </div>
                          </div>
                        </v-col>
                    </v-row>
                  </v-card>
              </component>
            </v-col>
          <!-- </v-row> -->
          <!-- <v-row align="center" justify="center"> -->
            <!-- repair -->
            <v-col cols="12" md="4" sm="6">
              <component :is="isMobile ? 'div' : 'router-link'" class="text-decoration-none w-100" :to="isMobile ? undefined : { name: 'RepairModule'}" :class="{ 'disabled-span' : checkDisability('Repair') }">
                  <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                    <v-row align="center" justify="space-between">
                        <v-col cols="9">
                          <h4 class="text-h6 font-weight-medium mb-0 text-left">
                              Repair
                          </h4>
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-col>
                    </v-row>
                    <!-- Data Row -->
                    <v-row class="mt-2" no-gutters>
                        <!-- Quantity -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-divider"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Quantity</div>
                              <div class="card-sub-header-value"> {{inv_status_count ? Number(inv_status_count.Repair?.total_count) : 0}}</div>
                          </div>
                        </v-col>
                        <!-- Average Ageing -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-ageing"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Average Ageing</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? Number(inv_status_count.Repair?.disposition_bucket_ageing?.toFixed(0)) + ' days': 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Value -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-value"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Value</div>
                              <div class="card-sub-header-value">
                                ₹{{inv_status_count ? formatToMillionBucket(Number(inv_status_count.Repair?.total_map_value)) : 0}}
                              </div>
                          </div>
                        </v-col>
                    </v-row>
                  </v-card>
              </component>
            </v-col>
            <!-- replacement -->
            <v-col cols="12" md="4" sm="6"  v-if="!$isWhirlpoolClient() || organization_name === 'Blubirch'">
              <component :is="isMobile ? 'div' : 'router-link'" class="text-decoration-none w-100" :to="isMobile ? undefined : { name: 'Replacement'}" :class="{ 'disabled-span' : checkDisability('Replacement') }">
                  <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                    <v-row align="center" justify="space-between">
                        <v-col cols="9">
                          <h4 class="text-h6 font-weight-medium mb-0 text-left">
                              Replacement
                          </h4>
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-col>
                    </v-row>
                    <!-- Data Row -->
                    <v-row class="mt-2" no-gutters>
                        <!-- Quantity -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-divider"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Quantity</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? Number(inv_status_count.Replacement?.total_count) : 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Average Ageing -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-ageing"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Average Ageing</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? Number(inv_status_count.Replacement?.disposition_bucket_ageing?.toFixed(0)) + ' days': 0}}
                              </div>
                          </div>
                        </v-col>
                        <!-- Value -->
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-value"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Value</div>
                              <div class="card-sub-header-value">
                                ₹{{inv_status_count ? formatToMillionBucket(Number(inv_status_count.Replacement?.total_map_value)) : 0}}
                              </div>
                          </div>
                        </v-col>
                    </v-row>
                  </v-card>
              </component>
            </v-col>
            <!-- <v-col cols="12" md="4" sm="6">
              <router-link class="text-decoration-none w-100" :to="{ name: 'Cannibalization'}" :class="{ 'disabled-span' : checkDisability('Replacement') }">
                  <v-card class="rounded-lg pa-4" elevation="6" @click="resetActiveTab">
                    <v-row align="center" justify="space-between">
                        <v-col cols="9">
                          <h4 class="text-h6 font-weight-medium mb-0 text-left">
                              Cannibalization
                          </h4>
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2" no-gutters>
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-divider"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Quantity</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? Number(inv_status_count.Cannibalization?.total_count) : 0}}
                              </div>
                          </div>
                        </v-col>
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-ageing"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Average Ageing</div>
                              <div class="card-sub-header-value">
                                {{inv_status_count ? Number(inv_status_count.Cannibalization?.disposition_bucket_ageing.toFixed(0) + ' days': 0}}
                              </div>
                          </div>
                        </v-col>
                        <v-col cols="4" class="text-left d-flex">
                          <v-divider vertical class="quantity-value"></v-divider>
                          <div class="pl-2">
                              <div class="card-sub-header-text">Value</div>
                              <div class="card-sub-header-value">
                                ₹{{inv_status_count ? formatToMillionBucket(Number(inv_status_count.Cannibalization?.total_map_value)) : 0}}
                              </div>
                          </div>
                        </v-col>
                    </v-row>
                  </v-card>
              </router-link>
            </v-col> -->
          <!-- </v-row> -->
          <!-- <v-row align="center" justify="center">             -->
              <!-- cannibalization -->
            <!-- <v-col block md="4" sm="12" xs12 :cols="6" v-if="!$isRelianceClient() && !$isWhirlpoolClient()">
                <v-card class="rounded-card" :elevation="10" v-if="inv_status_count">
                  <v-row class="ma-0 pa-0" @click="resetActiveTab">
                    <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                      <router-link class="text-decoration-none" :to="{ name: 'Cannibalization' }" :class="{ 'disabled-span' : checkDisability('Cannibalization') }">
                        <v-simple-table>
                          <template v-slot:default>
                            <tbody> -->
                              <!-- <tr align="center">
                                <td style="border:none">
                                  <img
                                    align="center"
                                    src="@/assets/images/icons/markdown.png"
                                    height="45"
                                    width="45"
                                  />
                                </td>
                                <td class=" " colspan="2" style="border:none">
                                  <h4 justify="center">Cannibalization</h4>
                                  <h5 justify="center" class="grey--text">
                                    Open Cases :
                                    <span class="text-color">{{ (Number(inv_status_count["Cannibalization"].to_be_cannibalized)) + (Number(inv_status_count["Cannibalization"].work_in_progress)) + (Number(inv_status_count["Cannibalization"].cannibalized))}}</span>
                                  </h5>
                                </td>
                              </tr>

                              <tr align="center" class="ma-1 pa-1 overflow-hidden">
                                <td class="ma-3 pa-3 td-border">
                                  <h3 class="high-alert">{{data_count.cannibalization.high}}</h3>
                                  <span>High alert</span>
                                </td>
                                <td class="td-border">
                                  <h3 class="medium-alert">{{data_count.cannibalization.medium}}</h3>
                                  <span>Medium alert</span>
                                </td>
                                <td class="td-border">
                                  <h3 class="low-alert">{{data_count.cannibalization.low}}</h3>
                                  <span>Low alert</span>
                                </td>
                              </tr>

                              <tr align="center">
                                <td class="td-border">
                                  <span>To Be Cannibalized:</span>
                                    <span class="text-color">{{ inv_status_count["Cannibalization"].to_be_cannibalized === undefined ? 0 : inv_status_count["Cannibalization"].to_be_cannibalized }}</span>
                                    <span>
                                      <img
                                        class="pull-right"
                                        align="center"
                                        src="@/assets/images/arrow.png"
                                        height="18"
                                        width="18"
                                        @click="proceedGrading(item)"
                                      />
                                    </span>
                                </td>
                                <td class="td-border">
                                  <span>Work In Progress:</span>
                                    <span class="text-color">{{ inv_status_count["Cannibalization"].work_in_progress === undefined ? 0 : inv_status_count["Cannibalization"].work_in_progress }}</span>
                                    <span>
                                      <img
                                        class="pull-right"
                                        align="center"
                                        src="@/assets/images/arrow.png"
                                        height="18"
                                        width="18"
                                        @click="proceedGrading(item)"
                                      />
                                    </span>
                                </td>
                                <td class="td-border">
                                  <span>Cannibalized:</span>
                                    <span class="text-color">{{ inv_status_count["Cannibalization"].cannibalized === undefined ? 0 : inv_status_count["Cannibalization"].cannibalized }}</span>
                                    <span>
                                      <img
                                        class="pull-right"
                                        align="center"
                                        src="@/assets/images/arrow.png"
                                        height="18"
                                        width="18"
                                        @click="proceedGrading(item)"
                                      />
                                    </span>
                                </td>
                              </tr>
                              <tr align="center">
                                <td class="td-border">
                                  <span></span>
                                  <span class="text-color"></span>
                                  <span>

                                  </span>
                                </td>
                                <td class="td-border">
                                  <span></span>
                                  <span class="text-color"></span>
                                  <span>

                                  </span>
                                </td>
                                <td class="td-border"></td>
                              </tr>     -->
                              
                              <!-- <tr align="center">
                                <td class="text-left" style="border:none">
                                  <h4 justify="center">Cannibalization</h4>
                                </td>
                                <td class="text-right" colspan="2" style="border:none">
                                  <v-icon>mdi-chevron-right</v-icon>
                                </td>
                              </tr>

                              <tr class="ma-1 pa-1 overflow-hidden text-left">
                                <td class="ma-3 pa-3">
                                  <h3 class="high-alert">Quantity - <span>{{inv_status_count["Cannibalization"] ? (Number(inv_status_count["Cannibalization"].to_be_cannibalized)) + (Number(inv_status_count["Cannibalization"].work_in_progress)) + (Number(inv_status_count["Cannibalization"].cannibalized)) : 0}}</span></h3>
                                </td>
                                <td class="text-left">
                                  <h3 class="low-alert">Average Ageing - <span>0</span></h3>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </router-link>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col> -->
            </v-row>
        </v-row>
        </div>
      </v-col>
    </div>
  </div>
</template>
            
<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import { mapState } from "vuex";
  import Loading from 'vue-loading-overlay';
  // import 'vue-loading-overlay/dist/vue-loading.css';
  // import 'vue-loading-overlay/dist/css/index.css';
  import { moduleAccessFunc } from '@/backend/axios/moduleAccess';
  export default {
    data() {
      return {
        headerText: "Reverse Disposition",
        data_count:'',
        inv_status_count:'',
        isLoading : false,
        primary_code: "#0275d8",
        fullPage : true,
        organization_name :'',
        totalQuantity: '',
        totalValuesCount:'',
        totalAgeingInDays:'',
        averageAgeingTotal:'',
        dispo_bucket_card_height : '400px'
      };
    },
    computed: {
      ...mapState(["currentUser", "signedIn"]),
      isMobile() {
        return this.$store.state.isMobile === true;
      }
    },
    created() {
      this.organization_name = this.$store.state.organization_name
      this.isLoading = true;
      this.getDispositionCount();
      this.get_Inventory_Status_Count();
      this.resetActiveTab();
    },
    components: {
      HeaderComponent,Loading
    },
    methods: {
      getDispositionCount() {
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/disposition_criticality_count")
          .then((response) => {
            this.data_count = response.data;
            console.log(response.data)
          })
          .catch((error) => {
            this.isLoading = false;
            this.$toast.error("Error in geting disposition count");
          });
      },
      
      // get_Inventory_Status_Count() {
      //   this.$httpSecured
      //     .get("/api/v1/warehouse/inventories/inventory_status_count")
      //     .then((response) => {
      //       this.inv_status_count = response.data;
      //       if(Object.keys(response.data).length){
      //         setTimeout(() => {
      //           this.isLoading = false;
      //         }, 500)
      //       }else{
      //       this.$toast.error("Error in geting inventory status count");
      //       }
      //       console.log(response.data)
      //     })
      //     .catch((error) => {
      //       this.isLoading = false;
      //       this.$toast.error("Error in geting inventory status count");
      //     });
      // },
      get_Inventory_Status_Count() {
        this.$httpSecured
          .get("/api/v1/warehouse/inventories/inventory_status_count")
          .then((response) => {
            this.inv_status_count = response.data;
            this.calculateTotalValues();
            this.calculateTotalQuantity();
            this.calculateAgeingDays(); 
            this.isLoading = false;
            console.log(response.data)
          })
          .catch((error) => {
            this.isLoading = false;
            this.$toast.error("Error in geting inventory status count");
          });
      }, 
      calculateTotalQuantity() {
        const keysToSum = {
          "Brand Call-Log": [
            "total_count",
          ],
        "Insurance": [
            "total_count",
        ],
        "Liquidation":[
            "total_count",
        ],
        "RTV": [
            "total_count",
        ],
        "Restock": [
            "total_count",
        ],
        "Repair": [
            "total_count",
        ],
        "Pending Transfer Out": [
            "total_count",
        ],
        "Replacement": [
            "total_count",
       ],
      };
      if(this.$isRelianceClient()){
          keysToSum["Pending Transfer Out"] = [
            "total_count",
          ]
      } else if(this.organization_name === 'Voltas'){
        keysToSum["Cannibalization"] = [
            "total_count",
          ]
      } else {

      }
      this.totalQuantity = 0
      for (let key in this.inv_status_count) {
        if (key in keysToSum) {
          const bucketData = this.inv_status_count[key];
          keysToSum[key].forEach(prop => {
            this.totalQuantity += Number(bucketData[prop] || 0);
          });
        }
      }
        // const replacementKeys = ["high", "medium", "low"];
        //   replacementKeys.forEach((key) => {
        //     this.totalQuantity += Number(this.data_count.replacement[key] || 0);
        //   });
        // }
      },
      calculateTotalValues() {
        const valueKey = "total_map_value";
        const allowedBuckets = [ 
                "Brand Call-Log",
                "Insurance",
                "Liquidation",
                "RTV",
                "Restock",
                "Repair",
                "Pending Transfer Out",
                "Replacement"
                ];
        if(this.organization_name === 'Voltas'){
          allowedBuckets.push("Cannibalization")
        }
        this.totalValuesCount = Object.entries(this.inv_status_count)
        .filter(([key]) => allowedBuckets.includes(key))
        .reduce((sum, [, bucketData]) => {
          return sum + (bucketData[valueKey] || 0);
        }, 0);
      },
      calculateAgeingDays() {
        const ageingKey = "disposition_bucket_ageing";
        const averageKey = "disposition_grn_ageing";
        const quantityKey = "total_count";

        const allowedBuckets = [
          "Brand Call-Log",
          "Insurance",
          "Liquidation",
          "RTV",
          "Restock",
          "Repair",
          "Pending Transfer Out",
          "Replacement"
        ];

        if (this.organization_name === "Voltas") {
          allowedBuckets.push("Cannibalization");
        }

        let totalAverageAgeing = 0;
        let totalWeightedQuantity = 0;

        for (let key in this.inv_status_count) {
          if (allowedBuckets.includes(key)) {
            const bucketCount = Number(this.inv_status_count[key][quantityKey] || 0);
            const bucketAgeing = Number(this.inv_status_count[key][averageKey] || 0);

            // Weighted ageing (sum of products)
            if (bucketAgeing > 0 && bucketCount > 0) {
              totalAverageAgeing += bucketAgeing * bucketCount;
              totalWeightedQuantity += bucketCount;
            }
          }
        }

        // Calculate weighted average
        // Using totalWeightedQuantity as denominator ensures consistency with numerator
        if (totalWeightedQuantity > 0) {
          console.log(totalAverageAgeing/totalWeightedQuantity)
          this.averageAgeingTotal = Math.round(totalAverageAgeing / totalWeightedQuantity);
        } else {
          this.averageAgeingTotal = 0;
        }
      },

      resetActiveTab(){
        // this.$store.commit('setActiveTab',{
        //   'active_tab' : ''
        // })
        this.$store.commit('unsetActiveTab')
      },  
      formatToMillion(value) {
        const million = value / 1000000; // Convert to millions
        return million.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 }) + 'M';
      },
      formatToMillionBucket(value) {
        const million = value / 1000000;
        return million.toLocaleString('en-IN', {currency: 'INR', minimumFractionDigits: 2 }) + 'M';
      },
      checkDisability(module){
        return moduleAccessFunc(this.$store.state.currentUser.roles[0],module)
      }
    },
  };
  
</script>
<style scoped>
  .v-card-100 { max-width: 100% !important; }
  .text-color { color: #0357d0; }
  .td-border { border: 2px solid #e5e5e5; }
  .v-data-table__wrapper { overflow-x: inherit !important; overflow-y: inherit !important; }
  .high-alert { color: #A2A3B4; font-size: 12px; font-weight: 600;}
  .high-alert span, .medium-alert span, .low-alert span {
    color: #000000;
  }
  .medium-alert { color: #A2A3B4; font-size: 12px; font-weight: 600; }
  .low-alert { color: #A2A3B4; font-size: 12px; font-weight: 600; }
  .main_wraper { float: left; width: 100%; position: relative; padding-left: 120px; }
  .v-data-table { height: auto !important; }
  .header-fixed { position: sticky; top: 0; z-index: 9999;}
  .rounded-card { 
    border-radius: 12px;
    padding: 16px;
}
  .v-data-table {
    border-radius: 12px;
  }
  @media (min-width: 1600px){
    .container--fluid{
      max-width: 70%;
    }
  }
 .customfontsize{
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 19px;
 }
.customfont{
  font-size: 1.78rem;
  font-weight: bold;
  color:#000;
  margin-bottom: 0px !important;
  line-height: 22.5px;
}
.disabled-span {
  pointer-events: none; 
  opacity: 0.5;
  color: gray;
}
.customUI{
  max-width: 100%;
  display: flex;
  margin: 0px auto;
}
/*@media (min-width: 1600px){
    .customUI{
      max-width: 80% !important;
    }
  }*/
  .dynamic-height {
    height: calc(var(--vh, 1vh) * 100 - 0px) !important;
  }
  .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 250px) !important;
  }
  .quantity-card {
    background-color: #4E79A766;
    color: #ffffff;
    min-width: 160px;
    text-align: center;
    opacity: 1.4;
    color:#2D2D2D
  }
.ageing-card {
  background-color: #EBA97166;
  color: #2d2d2d;
  min-width: 160px;
  text-align: center;
  opacity: 1.4;
}
.value-card {
  background-color: #D0BFCE66;
  color: #2d2d2d;
  min-width: 160px;
  text-align: center;
  opacity: 1.4;
}
.quantity-divider {
  border: 3px solid #B3C4D8 !important;
  margin: 8px 4px;
  opacity: 0.6;
  border-radius: 9px;
}
.quantity-ageing {
  border: 3px solid #F2D8C2 !important;
  margin: 8px 4px;
  opacity: 0.6;
  border-radius: 9px;
}
.quantity-value {
  border: 3px solid #E7E0E7 !important;
  margin: 8px 4px;
  opacity: 0.6;
  border-radius: 9px;
}
.card-header-text{
  font-size: 24px;
  font-weight: 700;
  color: 19px;
}
.card-bottom-text{
  font-size: 16px;
  font-weight: 500;
  color: #646464;
}
.card-sub-header-text{
  font-size: 14px;
  color: #A2A3B4;
  font-weight: 600;
}
.card-sub-header-value{
  font-size: 14px;
  font-weight: 600;
  color: #2D2D2D;
  padding-top: 5px;
}
@media (max-width: 1100px) and (min-width: 601px) {
  .card-sub-header-text {
    font-size: 10px;
  }
  .card-sub-header-value {
    font-size: 10px;
  }
}

/* Mobile styles (xs screens ≤ 600px) */
@media (max-width: 600px) {
  /* Remove container's default horizontal padding so cards go edge-to-edge */
  .mobile-container {
    padding-left: 13px !important;
    padding-right: 0 !important;
  }

  /* Summary row — tight vertical spacing, zero side gaps */
  .summary-row {
    padding: 6px 0 !important;
    margin: 0 !important;
  }

  /* Summary columns — zero horizontal padding to eliminate side gaps */
  .summary-col {
    padding: 8px 6px !important;
  }

  .summary-col .v-card {
    border-radius: 12px !important;
    padding: 12px 16px !important;
    margin: 0 !important;
  }

  .card-header-text {
    font-size: 20px;
    font-weight: 700;
  }

  .card-bottom-text {
    font-size: 13px;
    font-weight: 500;
    margin-top: 2px;
  }

  /* Disposition card grid — zero outer padding, small gap between cards */
  .customUI {
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Each disposition col: zero horizontal padding, tiny vertical gap */
  .customUI > .col,
  .customUI > [class*="col-"] {
    padding: 8px 6px !important;
  }

  .customUI .v-card {
    padding: 14px 16px !important;
    border-radius: 12px !important;
    margin: 0 !important;
    min-height: 100px;
  }

  .card-sub-header-text {
    font-size: 11px;
    color: #A2A3B4;
    font-weight: 600;
    white-space: nowrap;
  }

  .card-sub-header-value {
    font-size: 12px;
    font-weight: 600;
    color: #2D2D2D;
    padding-top: 3px;
    white-space: nowrap;
  }

  .quantity-divider,
  .quantity-ageing,
  .quantity-value {
    margin: 4px 2px !important;
  }

  .text-h6 {
    font-size: 16px !important;
    font-weight: 600 !important;
  }

  .dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 310px) !important;
  }

  .scrollable-container {
    padding-bottom: 50px !important;
  }
}

</style>